'use strict';
export default class ScrollManager {

    constructor() {
        this.scrollContainer = window;
    }

    scrollTo(elementSelector, callbackFunction = null, speed = null, element = null, modalSelector = null, offsetHeader = null) {
        let startY = this.currentYPosition();
        element = element ? element : document.querySelector(elementSelector);
        if (modalSelector) {
            this.scrollContainer = modalSelector;
        }

        let stopY = this.elmYPosition(element) - (offsetHeader ? offsetHeader : 44);
        let distance = stopY > startY ? stopY - startY : startY - stopY;

        if (!speed) {
            let speed = Math.round(distance / 100);
            if (speed >= 150) speed = 150;
        }

        let step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        let lastIteration = false;

        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                if ((leapY - step) < stopY) lastIteration = true;
                setTimeout(this._setTimeOutFunction.bind(this), timer * speed, leapY, callbackFunction, lastIteration);

                leapY += step;
                if (leapY > stopY) leapY = stopY;
                timer++;
            }
            return;
        }

        lastIteration = false;

        for (let i = startY; i > stopY; i -= step) {
            if ((leapY - step) < stopY) lastIteration = true;
            setTimeout(this._setTimeOutFunction.bind(this), timer * speed, leapY, callbackFunction, lastIteration);

            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }
        return false;
    }

    _setTimeOutFunction(leapY, callbackFunction, lastIteration) {
        this.scrollContainer.scrollTo(0, leapY);
        if (lastIteration && callbackFunction) {
            callbackFunction();
        }
    }

    currentYPosition() {
        if (self.pageYOffset) return self.pageYOffset;
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }

    elmYPosition(elm) {
        let y = elm.offsetTop;
        let node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        }
        return y;
    }

    smoothScroll(scrollBy, scrollTo, isUnderScrollTo) {
        let i =  scrollBy;
        const self = this;

        if (i < scrollTo && !isUnderScrollTo) {
            setTimeout(() => {
                window.scrollTo(0, i);
                self.smoothScroll(i + 50, scrollTo, isUnderScrollTo);
            }, 10);
        }else if (i > scrollTo && isUnderScrollTo) {
            setTimeout(() => {
                window.scrollTo(0, i);
                self.smoothScroll(i - 50, scrollTo, isUnderScrollTo);
            }, 10);
        }
    }
}